/**
* Specifically fetches a list for select components,
* mapping the results to a standard { label, value } format.
*/

export const getOptionsFromJson = (data, labelField = 'name', valueField = 'id') => {
    if (!Array.isArray(data)) {
        return [];
    }

    return data.map(item => ({
        label: item[labelField] || 'Unknown',
        value: String(item[valueField])
    }));
};
